import { render, staticRenderFns } from "./EventTicketDetailSidebarTicketImage.vue?vue&type=template&id=797eadf0&"
import script from "./EventTicketDetailSidebarTicketImage.vue?vue&type=script&lang=js&"
export * from "./EventTicketDetailSidebarTicketImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports